module.exports = __webpack_public_path__ + "img/Fabico_Clinic.c534e608.png";